import { render, staticRenderFns } from "./PrintThermal_Footer.vue?vue&type=template&id=c9a0fda8&"
import script from "./PrintThermal_Footer.vue?vue&type=script&lang=js&"
export * from "./PrintThermal_Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports